import { useCallback, useEffect, useState } from "react";

const OTP_TTL_SECONDS = 120;

const useOtpTimer = (active) => {
  const [remaining, setRemaining] = useState(OTP_TTL_SECONDS);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!active) return;
    setRemaining(OTP_TTL_SECONDS);
    const timer = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [active, tick]);

  const reset = useCallback(() => setTick((prev) => prev + 1), []);

  return { remaining, reset };
};

export default useOtpTimer;
